export enum FencePreviewItemTypeEnum {
  SealedPost = 'sealed-post',
  PostWithPlate = 'post-with-plate',
  Board = 'board',
  BoardCut = 'board-cut',
  HorizontalDecorativeBoard = 'horizontal-decorative-board',
  VerticalDecorativeBoard = 'vertical-decorative-board',
  HorizontalDecoration = 'horizontal-decoration',
  VerticalDecoration = 'vertical-decoration',
  HorizontalPanel = 'horizontal-panel',
  VerticalPanel = 'vertical-panel',
  TopProfile = 'top-profile',
  BottomProfile = 'bottom-profile',
  Door = 'door',
  BasePlate = 'base-plate',
  Spacer = 'spacer',
}
